import LsdApiModel from './global/LsdApiModel';

export default class ProjectSubCategoryStatsModel extends LsdApiModel {
	static get path(): string {
		return '/project_sub_categories/stats?projectCategory={?projectCategory}&expenseGroup={?expenseGroup}';
	}
}
